import { notificationTarget, type Notification } from "@estelle/domain";

/**
 * Where a notification opens — `notificationTarget` in `@estelle/domain`, which
 * a push message uses too, so the bell and the phone send the same
 * notification to the same place.
 */
export function notificationLink(
  notification: Pick<Notification, "entityType" | "entityId">,
): {
  to: string;
  search?: Record<string, string>;
} {
  return notificationTarget(notification);
}
